import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class AlertService {

  private message: Subject<IAlert>;
  constructor() {
    this.message = new Subject();
  }

  AlertNewmessege(message: IAlert): void {
    this.message.next(message);
    setTimeout(() => {
      this.doneAlert()
    }, 6000)
  }
  get alertMessage(): Observable<IAlert> {
    return this.message.asObservable()
  }
  doneAlert(): void {
    this.message.next(null);
  }
}


export interface IAlert {
  type: 'success' | 'error',
  message?: string
}